<script>
    import { getAudioGuide } from "../datasource/audio-guide-datasource";
    import GeneralButton from "../../../common/buttons/GeneralButton.svelte";
    import toast from "svelte-french-toast";
    import { replace } from "svelte-spa-router";
    import LoadingSquare from "../../../common/LoadingSquare.svelte";
    import { _ } from "svelte-i18n";
    import HeaderBar from "../../../components/header/HeaderBar.svelte";

    export let params = {};
    $: audioGuideId = params.id;
    $: audioGuidePromise = getAudioGuide(audioGuideId).then((audioGuide) => {
        audioGuideCode = audioGuide.code;
        return audioGuide;
    });

    $: inputValue = "";

    let audioGuideCode;

    function submitCode() {
        console.log("uff");
        if (audioGuideCode === inputValue) {
            const audioGuideCodeId = audioGuideId + "-code";
            localStorage.setItem(audioGuideCodeId, audioGuideCode);
            replace("/audio-guide/" + audioGuideId);
        } else {
            toast.error("Der eingegebene Code ist leider ungültig.");
        }
    }
</script>

<HeaderBar close on:actionClicked={() => replace("/onsite")} onSite />

<div
    class="headline-s"
    style="box-sizing:border-box;padding: 32px; height: 80%; display: flex; flex-direction: column"
>
    {#await audioGuidePromise}
        <LoadingSquare />
    {:then audioGuide}
        <div
            style="flex:1;display: flex; justify-content: center; flex-direction: column;"
        >
            <div class="headline-xs">{$_("audio_guide")}</div>
            <div class="headline-l" style="margin-bottom: 32px;">
                Geben sie den Code aus ihrer E-Mail ein
            </div>
            <input bind:value={inputValue} class="input-style" />
            <GeneralButton
                on:click={() => submitCode()}
                text={$_("continue")}
            />
        </div>
    {:catch}
        <div class="error">
            <span class="text-l" style="font-size: 24px;">
                {$_("entity_load_error")}
            </span>
        </div>
    {/await}
</div>

<style>
    .input-style {
        border: 1px solid var(--black-100);
        padding: 24px 20px;
        background: transparent;
        width: 100%;
    }
</style>
